export const Marquee = ({ text, dark = true }) => {
  const items = new Array(6).fill(text);
  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden py-8 border-y ${
        dark ? "bg-rr-navyDeep border-white/10" : "bg-white border-rr-line"
      }`}
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {items.map((t, i) => (
          <span
            key={`${t}-${i}`}
            className={`font-heading text-5xl md:text-7xl font-extrabold uppercase tracking-tight px-6 ${
              dark ? "text-white/[0.06]" : "text-rr-navy/[0.06]"
            }`}
            style={{ WebkitTextStroke: dark ? "1px rgba(255,255,255,0.12)" : "1px rgba(14,42,71,0.15)" }}
          >
            {t} &nbsp;•&nbsp;
          </span>
        ))}
      </div>
    </div>
  );
};
